import { Box, Container, Grid } from "@mui/material";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TopBar from "../../../components/TopBar/TopBar";
import "./ClinicPet.css";
import ClinicPetsTable from "./ClinicPetsTable";
import PetMaster from "./Master/PetMaster";
import Main from "./PetCharts.js/Main";

export const PETS_TAB_PATHS = {
  charts: "charts",
  contents: "contents",
  master: "master",
};

export const PETS_PATH_TO_TAB = {
  charts: "charts",
  contents: "contents",
  master: "master",
};

export const ClinicPetsRedirect = () => {
  const location = useLocation();
  const tabFromState = location.state?.selectedTab ?? location.state?.activeTab;
  const path = PETS_TAB_PATHS[tabFromState] ?? PETS_TAB_PATHS.contents;
  return <Navigate to={`/pets/${path}`} replace state={location.state} />;
};

const ClinicPets = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const selectedTab = PETS_PATH_TO_TAB[tab];

  const handleChangeTab = (nextTab) => {
    if (!nextTab || nextTab === selectedTab) return;
    const path = PETS_TAB_PATHS[nextTab] ?? PETS_TAB_PATHS.contents;
    navigate(`/pets/${path}`, { state: location.state });
  };

  if (!selectedTab) {
    return (
      <Navigate
        to={`/pets/${PETS_TAB_PATHS.contents}`}
        replace
        state={location.state}
      />
    );
  }

  return (
    <>
      {/* Tab Navigation - Same pattern as Appointments.js */}
      <TopBar
        sx={
          selectedTab === "contents" || selectedTab === "master"
            ? { pb: 1 }
            : undefined
        }
      >
        <Container maxWidth="xl">
          <Grid container spacing={0} className="flex-center">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={0}>
                <div className="flex-row">
                  <div
                    className="ph10pv3"
                    onClick={() => handleChangeTab("charts")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "charts"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Dashboard
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => handleChangeTab("contents")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "contents"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Contents
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => handleChangeTab("master")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "master"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Master
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </TopBar>

      {/* Tab Content */}
      {selectedTab === "charts" ? (
        <Box
          sx={{
            height: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "20px",
          }}
        >
          <Main />
        </Box>
      ) : null}
      {selectedTab === "contents" ? <ClinicPetsTable /> : null}
      {selectedTab === "master" ? <PetMaster /> : null}
    </>
  );
};

export default ClinicPets;
